import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Viz class to inform that the viz should be displayed in the viz switcher
 * @param {Visualization} Viz The visualization to enhance
 */
export const withVizSwitcher: PresetHOC<{
    includeInVizSwitcher?: boolean;
}> = (Viz) => {
    Viz.includeInVizSwitcher = true;

    return Viz;
};
